/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type MessagePreviewResource = {
    /**
     * Transform the resource into an array.
     */
    global_message_template_id?: number
    from_address?: string
    type?: MessagePreviewResource.type
    subject?: string
    content?:
        | {
              html?: string
              blade?: boolean
          }
        | {
              text?: string
          }
        | {
              message?: string
          }
}

export namespace MessagePreviewResource {
    export enum type {
        SMS = 'sms',
        UNLAYER = 'unlayer',
        HTML = 'html',
        TEXT = 'text'
    }
}
